module.exports = __webpack_public_path__ + "img/logo.f31f9f99.svg";